import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import { InfomodalComponent } from 'src/app/main/shared/infomodal/infomodal.component';
import { DataService } from 'src/app/main/shared/services/data.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-rainfall-forecast-sidebar',
  templateUrl: './rainfall-forecast-sidebar.component.html',
  styleUrls: ['./rainfall-forecast-sidebar.component.scss']
})
export class RainfallForecastSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();
  selected: string;
  queryParams: any = {};
  isInitialLoad: boolean = false;
  dateIndexLength: any;
  activeRadioList: boolean[] = [];
  selectedView: string = 'Admin';
  showViewToggle: boolean = false;
  modalRef: any;
  sourceOptions: any = ['IMD - GFS', 'ECMWF', 'IMD(WRF + GFS)', 'Google (WeatherNext 2)'];
  allSourceOptions: any = ['IMD - GFS', 'ECMWF', 'IMD(WRF + GFS)', 'Google (WeatherNext 2)', 'IMD-GRID', 'IMD-STATION'];
  selectedSource: any = 'ECMWF';
  sourceMapping: any = {
    'IMD - GFS': 'IMD_LONG_RANGE',
    'ECMWF': 'ECMWF',
    'IMD(WRF + GFS)': 'IMD_SHORT_RANGE',
    'Google (WeatherNext 2)': 'WEATHER_NEXT_GRAPH',
    'IMD-GRID': 'IMD_GRID',
    'IMD-STATION': 'IMD_STATION'
  }
  googleForecastLengths: any = [
    { label: '+24 H', value: '24' },
    { label: '+7 D', value: '7' }
  ]
  destroy: any = new Subject();
  subscriptions: any = [];
  sessionStorage: any = {
    params: {}
  };
  selectedECMWFType: any = 'anomaly';
  forecastLength: any = '24';
  rainfallMode: string = 'standard';

  constructor(private router: Router, private route: ActivatedRoute, private gisUtils: UtilsService, private modalService: NgbModal, private dataService: DataService, private gisMapComp: GisDimsMapComponent
  ) {
    this.selected = this.router.url.split("/")[2]
  }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents()
    this.setParams()
  }

  subscribeEvents() {
    const selectedParamsRef = this.gisUtils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.gisUtils.setSelectedParams(this.queryParams);
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.selectedSource = this.queryParams['source'] == 'IMD_LONG_RANGE' ? 'IMD - GFS'
          : this.queryParams['source'] == 'IMD_SHORT_RANGE' ? 'IMD(WRF + GFS)'
            : this.queryParams['source'] == 'WEATHER_NEXT_GRAPH' ? 'Google (WeatherNext 2)'
              : this.queryParams['source'] == 'IMD_GRID' ? 'IMD-GRID'
                : this.queryParams['source'] == 'IMD_STATION' ? 'IMD-STATION'
                  : this.queryParams['source']; 
        this.forecastLength = this.queryParams['forecastLength'];
        this.selectedECMWFType = isNullOrUndefined(this.queryParams['sourceType']) ? 'anomaly' : this.queryParams['sourceType']
        this.rainfallMode = this.queryParams['rainfallMode'] || 'standard';
        this.selectedView = this.queryParams['view'] || 'Admin';
        this.dateIndexLength = this.queryParams['forecastLength'] == '24' ? 9 : 7;
        this.activeRadioList = [];
        for (let i = 0; i < this.dateIndexLength; ++i) {
          if (i === this.blockNum) {
            this.activeRadioList.push(true);
          } else {
            this.activeRadioList.push(false);
          }
        }
        this.filterSourceOptions();
        this.checkViewToggleVisibility();
      }
    })
  }

  filterSourceOptions() {
    if (this.forecastLength === 'monthly' || this.forecastLength === 'seasonal' || this.forecastLength === 'deterministic') {
      this.sourceOptions = ['ECMWF'];
      if (this.selectedSource !== 'ECMWF') {
        this.selectedSource = 'ECMWF';
        this.sourceChange();
      }
    } else if (this.forecastLength === 'YTD') {
      this.sourceOptions = ['IMD-STATION', 'IMD-GRID'];
      if (this.selectedSource !== 'IMD-GRID' && this.selectedSource !== 'IMD-STATION') {
        this.selectedSource = 'IMD-STATION';
        this.sourceChange();
      }
    } else {
      this.sourceOptions = [...this.allSourceOptions.filter((s: string) => s !== 'IMD-GRID' && s !== 'IMD-STATION')];
    }
  }


  setParams() {
    // this.sessionStorage.params only gets populated inside subscribeEvents()'s "empty
    // BehaviorSubject" fallback branch, so on its own it can't tell "genuinely nothing to
    // restore" apart from "the live gisUtils.selectedParams value was already non-empty when
    // this fresh component mounted" (that branch is simply never reached in the latter case).
    // The rainfallStations Stations-login redirect destroys and remounts this component just
    // like GisDimsMapComponent, and GisDimsMapComponent.subscribeEvents() republishes the
    // preserved drilldown (locType/pUUID/etc., not just forecastLength) into
    // gisUtils.selectedParams before this component's own subscribeEvents() (called above, in
    // ngOnInit) synchronously reads it into this.queryParams — so checking that too avoids
    // stomping a legitimately restored State/District drilldown back to the user's default
    // Country-level location, while leaving every genuinely-empty fresh mount unaffected.
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length && !Object.keys(this.queryParams).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }


  ngOnChanges(change: SimpleChanges) {
    // let timeStamp = this.labelStrings[this.blockNum].groupName;
    // this.gisUtils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && this.labelStrings && this.labelStrings.length > 0) {
      if (!isNullOrUndefined(change.blockNum.currentValue)) {
        this.buttonClicked(change.blockNum.currentValue);
      }

    } else {
      this.buttonClicked(this.blockNum);
    }
    const totalLabels = (this.labelStrings && this.labelStrings.length) ? this.labelStrings.length : (this.dateIndexLength || 0);
    this.activeRadioList = [];
    for (let i = 0; i < totalLabels; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = { ...this.queryParams };
    }
    currentUrlParams['component'] = 'RAINFALLFORECAST';
    // if (this.selectedSource && this.sourceMapping[this.selectedSource]) {
    currentUrlParams['source'] = this.sourceMapping[this.selectedSource];
    // } else {
    //   currentUrlParams['source'] = 'ECMWF';
    // }
    currentUrlParams['sourceType'] = this.selectedECMWFType;
    currentUrlParams['forecastLength'] = this.forecastLength;
    currentUrlParams['view'] = this.selectedView;
    currentUrlParams['forecastLength'] = this.forecastLength
    currentUrlParams['rainfallMode'] = this.rainfallMode;
    if (!this.isBasinViewAllowed(currentUrlParams['forecastLength'])) {
      this.selectedView = 'Admin';
      // IMD-STATION supports no map/table drilldown, so switching onto it (e.g. from
      // IMD-GRID while drilled into a State/District) must always drop back to the Country
      // level rather than keeping the stale drilldown — see applyAdminViewParams() below.
      const noDrilldownSource = currentUrlParams['source'] === 'IMD_STATION';
      // if (!currentUrlParams['locType'] || currentUrlParams['locType'] === 'COUNTRY') {
      if (noDrilldownSource || !currentUrlParams['locType'] || currentUrlParams['locType'] === 'COUNTRY') {
        currentUrlParams = this.applyAdminViewParams(currentUrlParams);
      } else {
        currentUrlParams['view'] = 'Admin'; // just set view, keep existing location
      }
    }
    // Ensure GOOGLE always sends a compatible forecastLength ('24', '7', or '10' — the +7 D toggle value)
    if (this.selectedSource === 'Google (WeatherNext 2)') {
      if (currentUrlParams['forecastLength'] !== '24' && currentUrlParams['forecastLength'] !== '7' && currentUrlParams['forecastLength'] !== '10') {
        currentUrlParams['forecastLength'] = '24';
      }
    }
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      // currentUrlParams['view'] = 'Admin';

      const userLocationConfig = this.dataService.formQuerParamsVariables(this.gisMapComp.metaInfo.userDetailsJson.data.location, this.gisMapComp.metaInfo.userDetailsJson.data.locType);

      if (this.selectedSource === 'Google (WeatherNext 2)' && userLocationConfig.types.pType === 'COUNTRY') {
        currentUrlParams['pType'] = 'STATE';
        currentUrlParams['cType'] = 'DISTRICT';
        currentUrlParams['parentLoc'] = 'STATE';
        currentUrlParams['locType'] = 'STATE';
        // Try to find a state in the location hierarchy, otherwise fallback to AP (from sample)
        const stateInfo = userLocationConfig.locationInfo.state && userLocationConfig.locationInfo.state !== 'ALL'
          ? userLocationConfig.locationInfo.state.split('##')
          : ['ANDHRA PRADESH', 'cdf94322-30bf-456b-b0c6-b4038caebd6a'];
        currentUrlParams['pUUID'] = stateInfo[1];
        currentUrlParams['locName'] = stateInfo[0];
      } else {
        currentUrlParams['pType'] = userLocationConfig.types.pType;
        currentUrlParams['cType'] = userLocationConfig.types.cType || (userLocationConfig.types.pType === 'COUNTRY' ? 'STATE' : 'DISTRICT');
        currentUrlParams['parentLoc'] = userLocationConfig.types.pType;
        currentUrlParams['locType'] = userLocationConfig.types.pType;
        const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
        currentUrlParams['pUUID'] = currentLocations[1]
        currentUrlParams['locName'] = currentLocations[0]
      }

      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      // currentUrlParams['forecastLength'] = '24'
      this.isInitialLoad = false
    }
    this.gisUtils.setSelectedParams(currentUrlParams);
  }

  buttonClicked(blockNumber, from?: string) {
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
      localStorage.setItem("playBarIndex", blockNumber)
    }
    if (this.activeRadioList[blockNumber]) {
      this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  validate(i: any) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['fullLabel'];
    }
  }

  infoclick(value: any) {
    this.modalRef = this.modalService.open(InfomodalComponent, { backdrop: 'static', keyboard: true, windowClass: 'backgroundTransparent  infocomponent' })
    this.modalRef.componentInstance.selected = value;
  }

  sourceChange() {
    // Reset forecastLength to a valid value when switching to/from GOOGLE
    if (this.selectedSource === 'Google (WeatherNext 2)') {
      // '10' is what the +7 D time toggle emits; Google's 7-day path already handles it.
      if (this.forecastLength !== '24' && this.forecastLength !== '7' && this.forecastLength !== '10') {
        this.forecastLength = '24';
      }
    } else {
      // If coming from Google (WeatherNext 2) with '7', restore to '24' (default for others)
      if (this.forecastLength === '7' || this.forecastLength === 'weekly' || this.forecastLength === 'deterministic') {
        this.forecastLength = '24';
      }
    }
    // Rainfall (Deterministic + Extended) only exists under ECMWF — drop it on any other source.
    if (this.selectedSource !== 'ECMWF') {
      this.rainfallMode = 'standard';
    }
    this.checkViewToggleVisibility();
    this.requestSelectedFilterParams();
  }

  onForecastLengthChange(length: string) {
    this.forecastLength = length;
    // Rainfall (Deterministic + Extended) only exists under +6W — drop it on any other length.
    if (length !== 'weekly') {
      this.rainfallMode = 'standard';
    }
    this.requestSelectedFilterParams();
  }

  selectRainfallMode(mode: string) {
    if (this.rainfallMode === mode) {
      return;
    }
    this.rainfallMode = mode;
    let options: any = { ...this.queryParams };
    options['rainfallMode'] = mode;
    if (mode === 'extended' && this.selectedView === 'Basin') {
      // Extended mode only supports the Admin (India/State/District/Block) hierarchy.
      this.selectedView = 'Admin';
      options = this.applyAdminViewParams(options);
    }
    this.gisUtils.setSelectedParams(options);
  }

  rainFallActualToggle(i: any) {
    // if (i == 'actual') {
    //   const url = '/extremeweather/' + this.selected + '-actual/' + this.forecastLength + '/' + this.stateUrlId;
    //   this.router.navigateByUrl(url);
    // }
  }
  onECMWFTypeChange(type: any) {
    if (this.selectedECMWFType === type) {
      return;
    }
    this.selectedECMWFType = type
    // Anomaly percentage only applies to Ensemble Mean Anomaly, and must never turn on
    // automatically just because the user switched ensemble type.
    this.gisMapComp.isAnomalyPercentageActive = false;
    let options = { ...this.queryParams }
    options['sourceType'] = type
    this.gisUtils.setSelectedParams(options);
  }

  checkViewToggleVisibility() {
    const shouldShow = this.isBasinViewAllowed(this.forecastLength);
    this.showViewToggle = shouldShow;
    if (!shouldShow && this.selectedView === 'Basin') {
      this.onViewChange('Admin');
    }
  }
  isBasinViewAllowed(forecastLength: string): boolean {
    return forecastLength === 'weekly' || forecastLength === 'monthly' || forecastLength === 'seasonal';
  }
  isViewEnabled(view: string): boolean {
    return view !== 'Basin' || this.isBasinViewAllowed(this.forecastLength);
  }
  applyAdminViewParams(params: any) {
    const userLocationConfig = this.dataService.formQuerParamsVariables(
      this.gisMapComp.metaInfo.userDetailsJson.data.location,
      this.gisMapComp.metaInfo.userDetailsJson.data.locType
    );
    params['view'] = 'Admin';
    const currentLocType = this.queryParams['locType'];
    console.log('applyAdminViewParams - currentLocType:', currentLocType, 'queryParams:', this.queryParams);

    const basinLoctypes = ['BASINV2', 'SUBBASINV2'];
    // IMD-STATION supports no map/table drilldown, so it must never inherit a State/District/
    // Block location left over from IMD-GRID (or another time menu) — force the reset branch.
    const noDrilldownSource = params['source'] === 'IMD_STATION';
    if (!noDrilldownSource && currentLocType && currentLocType !== 'COUNTRY' && !basinLoctypes.includes(currentLocType)) {

      params['locType'] = this.queryParams['locType'];
      params['pType'] = this.queryParams['locType'];
      params['parentLoc'] = this.queryParams['locType'];
      params['cType'] = this.queryParams['cType'] ||
        (currentLocType === 'STATE' ? 'DISTRICT' : 'BLOCK');
      params['pUUID'] = this.queryParams['pUUID'];
      params['locName'] = this.queryParams['locName'];
      params['pEUUID'] = this.queryParams['pEUUID'];
      params['location'] = this.queryParams['location'];
    }

    else {
      params['locType'] = userLocationConfig.types.pType;
      params['pType'] = userLocationConfig.types.pType;
      params['parentLoc'] = userLocationConfig.types.pType;
      params['cType'] = userLocationConfig.types.cType || (userLocationConfig.types.pType === 'COUNTRY' ? 'STATE' : 'DISTRICT');
      params['pUUID'] = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##')[1];
      params['locName'] = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##')[0];
      params['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      params['location'] = userLocationConfig.locationInfo.location;
    }
    return params;
  }
  onViewChange(view: string) {
    if (!this.isViewEnabled(view)) {
      return;
    }
    if (this.selectedView === view) {
      return;
    }
    this.selectedView = view;
    // this.requestSelectedFilterParams()
    let currentParams: any = { ...this.queryParams };
    currentParams['view'] = view;
    const userLocationConfig = this.dataService.formQuerParamsVariables(
      this.gisMapComp.metaInfo.userDetailsJson.data.location,
      this.gisMapComp.metaInfo.userDetailsJson.data.locType
    );

    if (view === 'Basin') {
      currentParams['locType'] = 'COUNTRY';
      currentParams['pType'] = 'COUNTRY';
      currentParams['cType'] = 'BASINV2';
      currentParams['pUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentParams['locName'] = 'India';
      currentParams['location'] = userLocationConfig.locationInfo.country;
      if (currentParams['location'] && currentParams['location'].split('&').length > 1) {
        currentParams['location'] = currentParams['location'].split('&')[0];
      }
    } else {
      currentParams = this.applyAdminViewParams(currentParams);
    }

    this.gisUtils.setSelectedParams(currentParams);
  }
}
